module.exports = __webpack_public_path__ + "img/xiekangfeng.8e42453e.png";